export default "__VITE_ASSET__CQNmlf6Z__"